export default __webpack_public_path__ + "static/media/pointer.76955b02.webp";